export default "__VITE_ASSET__BKCDrSiw__"